import { GrupoUnidadMedidaInputProps } from '../../../interfaces/grupoUnidadMedida.ts'

export const grupoUnidadMedidaRegistroComposeService = (
  input: GrupoUnidadMedidaInputProps,
): any => {
  return {
    nombreGrupo: input.nombreGrupo,
    codigoUnidadMedidaBase: input.codigoUnidadMedidaBase,
    definicion: input.definicion,
  }
}
